import { selectUser } from '@/redux/auth/authSlice';
import { useAppSelector } from '@/redux/hooks';
import { Modal } from 'antd';
import { useCallback, useState } from 'react';
import PosForm from './PosForm';

const PosModal = () => {
  const user = useAppSelector(selectUser);
  const [open, setOpen] = useState(true);

  const closeModal = useCallback(() => setOpen(false), []);

  return (
    <Modal
      title="POS Creation"
      centered
      destroyOnClose
      open={open}
      onCancel={closeModal}
      footer={null}
      closable={false}
      maskClosable={false}
    >
      <PosForm onSubmit={closeModal} defaultName={`pos ${user?.userPosCount ?? 0 + 1}`} />
    </Modal>
  );
};

export default PosModal;
